import { EntityId } from "@jackfruit/common"
import { useCallback, useState } from "react"
import { useProcessActions } from "~/hooks/useProcessActions"
import { wait } from "~/services/Utils"
import { useCloudProviderContext } from "./useCloudProviderContext"

export const useCloudProviderActions = () => {
  const {
    setIsImportingImages,
    isImportingImages,
    closeCloudProviderModal,
    imageRegionId,
    lineItemId,
    productId,
  } = useCloudProviderContext()

  const [selectedImageIds, setSelectedImageIds] = useState<EntityId[]>([])
  const process = useProcessActions()

  const hasSelectedImages = selectedImageIds.length > 0

  const handleImageSelect = useCallback((id: EntityId) => {
    setSelectedImageIds(prev => {
      if (prev.find(selectedId => selectedId === id)) {
        return prev.filter(selectedId => selectedId !== id)
      } else {
        return [...prev, id]
      }
    })
  }, [])

  // files are handed over as-is; strings are fetched by the saga
  const handleUploadImages = async (images: (File | string)[]) => {
    setIsImportingImages(true)
    if (lineItemId) {
      process.fillLineItemImageRegionsWithImageUrls({
        lineItemId,
        imageRegionId: imageRegionId ?? undefined,
        imageUrls: images,
        onComplete: async () => {
          setSelectedImageIds([])
          await wait(1000)
          setIsImportingImages(false)
          closeCloudProviderModal()
        },
      })
    } else {
      process.createLineItemForProductIdWithImageUrl({
        productId: productId ?? undefined,
        imageUrls: images,
        onComplete: async () => {
          setSelectedImageIds([])
          await wait(1000)
          setIsImportingImages(false)
          closeCloudProviderModal()
        },
      })
    }
  }

  return {
    selectedImageIds,
    hasSelectedImages,
    isImportingImages,
    handleImageSelect,
    handleUploadImages,
    closeCloudProviderModal,
  }
}
